module.exports = __webpack_public_path__ + "static/media/unitEmpty.b597d42c.png";